import React from "react";
import CourseHeader from "../Shared/CourseHeader";

const InformationTechnologyHeader = () => {
  return <CourseHeader />;
};

export default InformationTechnologyHeader;
